import React, { useEffect, useState } from 'react';
import PlanDetailsModal from '../subscription/PlanDetailsModal';
import SubscriptionHero from '../subscription/SubscriptionHero';
import SubscriptionPlans from '../subscription/SubscriptionPlans';
import SubscriptionBenefits from '../subscription/SubscriptionBenefits';
import PaymentSection from '../subscription/PaymentSection';
import CouponSection from '../subscription/CouponSection';
import { axiosRequest } from '../../../_config/apiClient';

const SubscriptionPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);

    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(false);

    const openPlanDetails = (plan) => {
        setSelectedPlan(plan);
        setIsModalOpen(true);
    };

    // ✅ API CALL
    const fetchSubscriptionPlans = async () => {
        try {
            setLoading(true);

            const res = await axiosRequest(
                "post",
                "/user/getSubscriptionPlans",
                {},
                {
                    Authorization: `Bearer ${localStorage.getItem("user")}`,
                }
            );

            setPlans(res.data || []);
        } catch (err) {
            console.error("Subscription plans error", err);
            setPlans([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubscriptionPlans();
    }, []);
    return (
        <div className="w-full max-w-[1400px] mx-auto  lg:px-6 py-6 ">
            <SubscriptionHero />
            <SubscriptionPlans
                plans={plans}
                loading={loading}
                onPlanClick={openPlanDetails}
            />
            <SubscriptionBenefits />
            <CouponSection />
            <PaymentSection />
            <PlanDetailsModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                plan={selectedPlan}
            />

            <footer className="mt-20 text-center text-[12px] tracking-tight md:text-[18px] text-[#333333] font-inter border-t border-[#333333] pt-10">
                <p>   © 2026 BaapBola. All rights reserved.</p>
                <p>
                    Prime Subscription subscriptions are non-refundable once cancelled. Cancel anytime from account settings.
                </p>

            </footer>
        </div>
    );
};

export default SubscriptionPage;